/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { XPTransactionHistoryItem } from './XPTransactionHistoryItem';
import {
    XPTransactionHistoryItemFromJSON,
    XPTransactionHistoryItemFromJSONTyped,
    XPTransactionHistoryItemToJSON,
    XPTransactionHistoryItemToJSONTyped,
} from './XPTransactionHistoryItem';
import type { GamingXPTransactionHistoryResponsePagination } from './GamingXPTransactionHistoryResponsePagination';
import {
    GamingXPTransactionHistoryResponsePaginationFromJSON,
    GamingXPTransactionHistoryResponsePaginationFromJSONTyped,
    GamingXPTransactionHistoryResponsePaginationToJSON,
    GamingXPTransactionHistoryResponsePaginationToJSONTyped,
} from './GamingXPTransactionHistoryResponsePagination';

/**
 * 
 * @export
 * @interface GamingXPTransactionHistoryResponse
 */
export interface GamingXPTransactionHistoryResponse {
    /**
     * 
     * @type {Array<XPTransactionHistoryItem>}
     * @memberof GamingXPTransactionHistoryResponse
     */
    transactions?: Array<XPTransactionHistoryItem>;
    /**
     * 
     * @type {GamingXPTransactionHistoryResponsePagination}
     * @memberof GamingXPTransactionHistoryResponse
     */
    pagination?: GamingXPTransactionHistoryResponsePagination;
    /**
     * Applied time filter
     * @type {string}
     * @memberof GamingXPTransactionHistoryResponse
     */
    timeFilter?: string;
    /**
     * Start date of filter period
     * @type {Date}
     * @memberof GamingXPTransactionHistoryResponse
     */
    startDate?: Date;
    /**
     * End date of filter period
     * @type {Date}
     * @memberof GamingXPTransactionHistoryResponse
     */
    endDate?: Date;
}

/**
 * Check if a given object implements the GamingXPTransactionHistoryResponse interface.
 */
export function instanceOfGamingXPTransactionHistoryResponse(value: object): value is GamingXPTransactionHistoryResponse {
    return true;
}

export function GamingXPTransactionHistoryResponseFromJSON(json: any): GamingXPTransactionHistoryResponse {
    return GamingXPTransactionHistoryResponseFromJSONTyped(json, false);
}

export function GamingXPTransactionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamingXPTransactionHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'transactions': json['transactions'] == null ? undefined : ((json['transactions'] as Array<any>).map(XPTransactionHistoryItemFromJSON)),
        'pagination': json['pagination'] == null ? undefined : GamingXPTransactionHistoryResponsePaginationFromJSON(json['pagination']),
        'timeFilter': json['timeFilter'] == null ? undefined : json['timeFilter'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}

export function GamingXPTransactionHistoryResponseToJSON(json: any): GamingXPTransactionHistoryResponse {
    return GamingXPTransactionHistoryResponseToJSONTyped(json, false);
}

export function GamingXPTransactionHistoryResponseToJSONTyped(value?: GamingXPTransactionHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactions': value['transactions'] == null ? undefined : ((value['transactions'] as Array<any>).map(XPTransactionHistoryItemToJSON)),
        'pagination': GamingXPTransactionHistoryResponsePaginationToJSON(value['pagination']),
        'timeFilter': value['timeFilter'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
    };
}

